import { render, staticRenderFns } from "./plate_reviewer_home.vue?vue&type=template&id=25488517"
import script from "./plate_reviewer_home.vue?vue&type=script&lang=js"
export * from "./plate_reviewer_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports